/** One option of a filter pill's checklist. */
interface PillOption {
	id: number | string;
	title: string;
}

/**
 * The options a paged, searchable filter offers: everything picked, first, then the loaded page
 * without what is already listed. The loaded page is only the current search's results, so a
 * pick that falls outside it was counted by the pill but could not be unticked (PREC-4434).
 */
export const selectedOptionsFirst = <T extends PillOption>(selected: T[], loaded: T[]): T[] => {
	const pickedIds = new Set(selected.map((option) => option.id));

	return [...selected, ...loaded.filter((option) => !pickedIds.has(option.id))];
};
